function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1.1337,0,0,1.1337,-10.8621,-4.46343)"
}, React.createElement("g", {
  transform: "matrix(0.882068,0,0,0.882068,9.59541,3.95135)"
}, React.createElement("path", {
  d: "M21.923,9.923L11.395,20.452C11.395,20.452 9.325,16.313 9.325,16.313C8.955,15.572 8.053,15.272 7.313,15.642C6.572,16.012 6.272,16.914 6.642,17.655L9.642,23.655C9.858,24.086 10.268,24.387 10.744,24.464C11.219,24.542 11.704,24.385 12.044,24.044L24.044,12.044C24.63,11.459 24.63,10.509 24.044,9.923C23.459,9.338 22.509,9.338 21.923,9.923Z"
})), React.createElement("g", {
  transform: "matrix(0.949919,0,0,0.949919,8.49548,1.90151)"
}, React.createElement("path", {
  d: "M16,2.607C8.056,2.607 1.607,9.056 1.607,17C1.607,24.944 8.056,31.393 16,31.393C23.944,31.393 30.393,24.944 30.393,17C30.393,9.056 23.944,2.607 16,2.607ZM16,5.393C22.406,5.393 27.607,10.594 27.607,17C27.607,23.406 22.406,28.607 16,28.607C9.594,28.607 4.393,23.406 4.393,17C4.393,10.594 9.594,5.393 16,5.393Z"
})));

var SvgAccept = function SvgAccept(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccept, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accept.108fb778.svg";
export { ForwardRef as ReactComponent };